/*
 * @Description: 
 * @Autor: jyf
 * @Date: 2022-03-23 09:07:14
 * @LastEditors: jyf
 * @LastEditTime: 2022-03-23 10:08:43
 */

import Vue from 'vue';
import { MessageBox, Message } from 'element-ui';
const directive = function () {
    //防重复点击事件
    Vue.directive('noReClick', function (el: HTMLFormElement, binding) {
        console.log('binding', binding);

        el.onclick = function (e) {
            if (!el.disabled) {
                el.disabled = true;
                setTimeout(() => {
                    el.disabled = false;
                }, binding.value || 1500);
            }
        };
    });
    //无权限点击事件[button]
    Vue.directive('noPermission', function (el: HTMLFormElement, binding, vnode) {
        var authlist = localStorage.getItem("mlssloginAd").split(",") ? localStorage.getItem("mlssloginAd").split(",") : [];
        // var authlist = sessionStorage.getItem("webMenus") ? sessionStorage.getItem("webMenus").split(",") : localStorage.getItem("webMenus").split(",") ? localStorage.getItem("webMenus").split(",") : [];
        if (!authlist.includes(binding.value)) {
            vnode.componentInstance.$off('click');
            vnode.componentInstance.$on('click', function () {
                Message.warning('没有权限');
            });
        };
    });
    //无权限 移除Dom元素
    Vue.directive('noPermissionDom', function (el: HTMLFormElement, binding) {
        var authlist = localStorage.getItem("mlssloginAd").split(",") ? localStorage.getItem("mlssloginAd").split(",") : [];
        // var authlist = sessionStorage.getItem("webMenus") ? sessionStorage.getItem("webMenus").split(",") : localStorage.getItem("webMenus").split(",") ? localStorage.getItem("webMenus").split(",") : [];
        if (!authlist.includes(binding.value)) {
            el.parentNode && el.parentNode.removeChild(el);
        }
    });
    //水波纹指令
    Vue.directive('waves', {
        bind: function (el, binding) {
            el.classList.add('waves-effect');
            let modifiers = Object.keys(binding.modifiers)[0], duration = +binding.expression || 200;
            !!modifiers && el.classList.add(`waves-${modifiers}`);
            function convertStyle(obj) {
                let style = '';
                for (let a in obj) {
                    if (obj.hasOwnProperty(a)) {
                        style += `${a}:${obj[a]};`
                    }
                }
                return style;
            }

            el.addEventListener('mousedown', function (e) {
                let ripple = document.createElement('div');
                ripple.classList.add('waves-ripple');
                el.appendChild(ripple);

                let styles = {
                    left: `${e.layerX}px`,
                    top: `${e.layerY}px`,
                    opacity: 1,
                    transform: `scale(${(el.clientWidth / 100) * 10})`,
                    'transition-duration': `${duration}ms`,
                    'transition-timing-function': 'ease-in-out'
                };
                ripple.setAttribute('style', convertStyle(styles));
                setTimeout(function () {
                    ripple.setAttribute('style', convertStyle({
                        opacity: 0,
                        transform: styles.transform,
                        left: styles.left,
                        top: styles.top,
                    }));
                    setTimeout(function () {
                        ripple && el.removeChild(ripple);
                    }, duration * 3);
                }, duration);
            });
        },
    });

};

export default directive;
